import { rtkApi } from '@/shared/api/rtkApi';

export const maxApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    registerWebhook: builder.mutation({
      query: (_arg?: void) => ({
        url: '/v1/superadmin/max/register-webhook',
        method: 'POST',
      }),
      invalidatesTags: ['MaxBindings'],
    }),
    sendTestMessage: builder.mutation({
      query: (payload) => ({
        url: '/v1/superadmin/max/send-test',
        method: 'POST',
        body: payload,
      }),
    }),
    getMaxBindings: builder.query({
      query: (page = 1) => ({
        url: '/v1/superadmin/max/bindings',
        method: 'GET',
        params: { page },
      }),
      providesTags: ['MaxBindings'],
    }),
  }),
});

export const { useRegisterWebhookMutation, useSendTestMessageMutation, useGetMaxBindingsQuery } = maxApi;
